import React from 'react';

const socialLinks = {
  facebook: 'https://www.facebook.com/Swami-Ayurveda-1261391000738608/',
  instagram: 'https://instagram.com/swami_ayurveda/',
  pinterest: 'https://www.pinterest.com/swamiayurveda',
  x: 'https://x.com/SwamiAyurveda',
};

const SocialButtons = ({ sm = false, light = false }) => {
  const containerSize = sm ? 'w-10 h-10' : 'w-12 h-12';
  const iconSize = sm ? 'text-base' : 'text-xl';
  const spacing = sm ? 'space-x-3' : 'space-x-4';
  
  const getButtonStyles = (platform) => {
    const baseStyles = `${containerSize} rounded-full flex items-center justify-center transition-all duration-200 transform hover:scale-110 hover:shadow-lg`;
    
    if (light) {
      // Light theme for use on dark backgrounds
      switch (platform) {
        case 'instagram':
          return `${baseStyles} bg-white/20 text-white border border-white/30 hover:bg-white hover:text-pink-600`;
        case 'facebook':
          return `${baseStyles} bg-white/20 text-white border border-white/30 hover:bg-white hover:text-blue-600`;
        case 'x':
          return `${baseStyles} bg-white/20 text-white border border-white/30 hover:bg-white hover:text-gray-900`;
        case 'pinterest':
          return `${baseStyles} bg-white/20 text-white border border-white/30 hover:bg-white hover:text-red-600`;
        default:
          return `${baseStyles} bg-white/20 text-white border border-white/30 hover:bg-white hover:text-primary`;
      }
    } else {
      // Dark theme for use on light backgrounds
      switch (platform) {
        case 'instagram':
          return `${baseStyles} bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:from-purple-600 hover:to-pink-600`;
        case 'facebook':
          return `${baseStyles} bg-blue-600 text-white hover:bg-blue-700`;
        case 'x':
          return `${baseStyles} bg-gray-900 text-white hover:bg-black`;
        case 'pinterest':
          return `${baseStyles} bg-red-600 text-white hover:bg-red-700`;
        default:
          return `${baseStyles} bg-primary text-white hover:bg-primary-dark`;
      }
    }
  };

  const socialPlatforms = [
    { key: 'instagram', icon: 'fab fa-instagram', label: 'Instagram' },
    { key: 'facebook', icon: 'fab fa-facebook-f', label: 'Facebook' },
    { key: 'x', icon: 'fab fa-twitter', label: 'Twitter' },
    // { key: 'pinterest', icon: 'fab fa-pinterest-p', label: 'Pinterest' },
  ];
  
  return (
    <div className="flex justify-center items-center">
      <div className={`flex ${spacing}`}>
        {socialPlatforms.map(({ key, icon, label }) => (
          <a 
            key={key}
            target="_blank" 
            rel="noopener noreferrer" 
            href={socialLinks[key]}
            className={getButtonStyles(key)}
            aria-label={`Follow us on ${label}`}
            title={`Follow us on ${label}`}
          >
            <i className={`${icon} ${iconSize}`}></i>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialButtons;
